module.exports = __webpack_public_path__ + "static/media/logo_without_claim.b42bdd31.svg";